export default "__VITE_ASSET__13cccdc1__"